import React, { Component } from 'react'
import { observer } from 'mobx-react'
import AnalysisChart from '@common/AnalysisChart'
import { ZHI_TUI_BAO } from '@common/AnalysisChart/constant'
import { Flex } from 'hljd'
import { getExportUrl } from '@util'
import { toJS } from 'mobx'
import { Table, Button } from 'hljd'

@observer
export default class extends Component {
  state = {
    dataSource: [],
    params: {}
  }

  render() {
    const { dataSource } = this.state

    return (
      <div>
        <AnalysisChart
          productType={ZHI_TUI_BAO}
          onDataLoaded={(data, params) => {
            this.setState({ dataSource: data.details || [], params })
          }}
        />

        <Flex style={{ marginBottom: 30, color: '#333' }} sp>
          <div>数据明细</div>
          <Button
            onClick={() => {
              const { start_day, end_day } = this.state.params
              const url = getExportUrl(
                '/p/wedding/index.php/admin/CpmBalance/flowPacketStatisticsExcel',
                {
                  start_day,
                  end_day
                }
              )

              window.open(url)
            }}
          >
            下载表格
          </Button>
        </Flex>

        <Table
          columns={[
            { title: '日期', dataIndex: 'daily_date' },
            { title: '曝光展示(次)', dataIndex: 'daily_display_count' },
            { title: '点击量(次)', dataIndex: 'daily_click_count' },
            { title: '点击率', dataIndex: 'daily_click_percent' },
            { title: '感兴趣(次)', dataIndex: 'daily_interest_count' },
            { title: '转化(次)', dataIndex: 'daily_convert_count' }
          ]}
          dataSource={toJS(dataSource).reverse()}
        />
      </div>
    )
  }
}
